export const FLASH_THINGS_TO_KNOW_ROW_KEYS = {
  checkIn: 'check-in',
  checkOut: 'check-out',
  inclusions: 'inclusions',
  cancellation: 'cancellation',
  dateChanges: 'date-changes',
  finePrint: 'fine-print',
} as const

export const BEDBANK_THINGS_TO_KNOW_ROW_KEYS = {
  checkIn: 'check-in',
  checkOut: 'check-out',
  checkInInstructions: 'check-in-instructions',
  fees: 'fees',
  pets: 'pets',
  general: 'general',
  safety: 'safety',
  /** Every supplier policy (finePrint.policies[key]) collapses onto this single row -- matches
   * BedbankThingsToKnow.tsx's own single `key: 'policies'` row, not one row per policy. */
  policies: 'policies',
  cancellation: 'cancellation',
  finePrint: 'fine-print',
} as const
